module.exports = __webpack_public_path__ + "img/introduction_bg3.23e7b383.png";